import { h, Fragment } from "preact";
import { useState, useEffect, useContext } from "preact/hooks";
import { Alert, Box, Button, Chip, Grid, Paper, Stack, Tooltip, Typography } from "@mui/material";
import { withStyles } from "@mui/styles";
import { green } from "@mui/material/colors";
import palette from "../../theme/palette";
import { AppContext } from "../../AppContext";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

import CircularProgressWithLabel from "../Common/CircularProgressWithLabel";
import BackButton from "../Common/BackButton";
import NavBreadcrumbs from "../Common/NavBreadcrumbs";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

import TaskIcon from '@mui/icons-material/Task';
const ColorButton = withStyles((theme) => ({
	root: {
		color: "#FFFFFF",
		backgroundColor: green[500],
		"&:hover": {
			backgroundColor: green[700],
		},
	},
}))(Button);

export default function Sellers({ uid, step }) {
	//console.log("Sellers", uid, step);
	const [state, setState] = useState({ ctx: undefined });

	const app = useContext(AppContext);
	useEffect(() => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/dlsel/" + uid, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						setState((state) => ({
							...state,
							ctx: res.pld,
						}));

						break;
					case "err":
						break;
					default:
						break;
				}
			});
	}, []);


	useEffect(() => {

		if (step === "SLC") {
			//if (state.ctx && state.ctx.complete === false && state.ctx.sellers.length > 0) {
			var lbl = (
				<div>
					<Box display="flex" justifyContent="space-between" alignItems="flex-start">
						<Box>
							<Typography variant="h5">La liste du ou des vendeurs est-elle bien complète ?</Typography>
							<Typography variant="body1">
								Pour générer le mandat de vente à signer électroniquement par tous les vendeurs,
							</Typography>
							<Typography variant="body1">
								nous devons savoir si tous les vendeurs figurent bien dans ce dossier de vente :)
							</Typography>
						</Box>
					</Box>
				</div>
			);

			var actions = (
				<Button
					variant="contained"
					startIcon={<TaskIcon />}
					onClick={() => {
						app.refPopUp.current.handleChangeState(
							{
								opened: true,
								type: "040",
								params: {
									uid: uid
								}
							}
						)
					}} >
					OUI
				</Button>

			);
			app.refHeader.current.handleChangeState({
				guidelines: {
					message: lbl,
					actions: [actions],

				}
			})
		}


	}, [])



	if (state.ctx === undefined) return;
	//console.log("sstate", state.ro);
	return (
		<div >

			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Paper style="padding: 10px">
						<Box display="flex" justifyContent="space-between" alignItems="center">

							<Box>
								<BackButton tooltip={"Revenir au dossier"} from={(state.ctx.role == "AM"
									? "/7bac6cb9d6ee4d70b1315393725f3a34/" + uid
									: (state.ctx.role == "VN" || state.ctx.role == "VNP")
										? "/11d1355181ac4376a09980601b420617/" + uid
										: "/login")} />

								{/* <NavBreadcrumbs from={(state.ctx.role == "AM"
									? "/7bac6cb9d6ee4d70b1315393725f3a34/" + uid
									: (state.ctx.role == "VN" || state.ctx.role == "VNP")
										? "/11d1355181ac4376a09980601b420617/" + uid
										: "/login")} /> */}

							</Box>
							<Box>
								<Typography variant="h5" >
									Gestion des vendeurs
								</Typography>
							</Box>


							<Box>
								{state.ctx && !state.ctx.mandate && state.ctx.sellers && state.ctx.sellers.length > 0 && <Button
									variant="contained"
									onClick={() => {
										state.ctx.has_location_and_type
											? state.ctx.complete
												? app.refPopUp.current.handleChangeState(
													{
														opened: true,
														type: "002",
														params: {
															yes_action: () => {

																app.refPopUp.current.handleChangeState(
																	{
																		opened: true,
																		type: "008",
																		users: state.ctx.sellers.filter((seller) => { return !seller.represented }),
																		uid: uid,
																		src: "dus",
																		side: "VN"
																	}
																)

															},
															title: "Attention",
															body: (
																<div>
																	<Typography variant="body1" gutterBottom>
																		Le mandat de vente a déjà été émis, une modification apportée à un ou plusieurs
																		vendeurs va entraîner son annulation et un nouveau processus de signature.
																	</Typography>
																	<Typography variant="h5" gutterBottom>
																		Voulez vous vraiment rajouter un vendeur?
																	</Typography>
																</div>
															)
														}
													}
												) :
												app.refPopUp.current.handleChangeState(
													{
														opened: true,
														type: "008",
														users: state.ctx.sellers.filter((seller) => { return !seller.represented }),
														uid: uid,
														src: "dus",
														side: "VN"
													}
												)
											: app.refPopUp.current.handleChangeState(
												{
													opened: true,
													type: "001",
													params: {
														title: "Attention",
														body: (
															<div>
																<Typography variant="body1" gutterBottom>
																	Vous ne pouvez pas rajouter un vendeur sans avoir d'abord spécifié une adresse et un
																	type de bien
																</Typography>
																<Button>Gérer le bien du dossier de vente</Button>
															</div>
														),
													}
												}
											)

									}}
								>
									Ajouter un vendeur
								</Button>}
							</Box>
						</Box>
					</Paper>
				</Grid>

				{state.ctx && state.ctx.complete && <Grid item xs={12} >
					<Paper>
						<Alert severity="success" >
							La liste de vendeurs est complète
						</Alert>
					</Paper>

				</Grid>}

				{state &&
					state.ctx &&
					state.ctx.sellers.map((s) => {
						//const nb_u = 0; //s.up_u.length;
						return (
							<Grid item xs={12} md={6} key={s.uid}>
								<Paper style="padding: 10px; height: 100%">
									{" "}
									<Box
										display="flex"
										alignItems="center"
										p={1}

									//bgcolor="background.paper"
									>
										{!state.ctx.ro && (
											<Box
												p={1}
												flexGrow={2}
												//bgcolor="grey.300"
												onClick={() => {
													window.location.href = "/du/" + s.uid + "?from=" + window.location.href;
												}}
												style=" cursor: pointer;"
											>
												<Typography>{s.name}</Typography>
											</Box>
										)}
										{state.ctx.ro && (
											<Box p={1} flexGrow={2}>
												<Typography>{s.name}</Typography>
											</Box>
										)}
										<Box p={1} flexGrow={1}>
											{s.up_u && (
												<Tooltip
													title={
														<Fragment>
															<Typography variant="body1" style="color: white;">
																Il reste {s.up_u.length} élément{s.up_u.length > 1 ? "s" : ""} à préciser
															</Typography>

															{/* {s.up_u.map((undn) => {
																return <Typography style="color: white;">{undn}</Typography>;
															})} */}
														</Fragment>
													}
													aria-label="add"
												>
													<span>
														<CircularProgressWithLabel value={(100 * s.up_d) / (s.up_d + s.up_u.length)} />
													</span>
												</Tooltip>
											)}
											{/* {s.up_u === [] && (
												<Fragment>
													<div>
														<Tooltip title={"Nous avons toutes les informations nécessaires"}>
															<Chip
																variant="outlined"
																style={{
																	color: palette.success.main,
																}}
																icon={
																	<AccountCircleIcon
																		style={{
																			color: palette.success.main,
																		}}
																	/>
																}
																label="Profil utilisateur complet"
															/>
														</Tooltip>
													</div>
													{state.ctx.complete && (
														<div style="margin-bottom: 10px;">
															<Tooltip title={"Statut de votre mandat de vente"}>
																<Chip
																	variant="outlined"
																	style={{
																		marginTop: "10px",
																		color: s.hsm
																			? palette.success.main
																			: s.hsm === false
																				? palette.error.main
																				: palette.warning.main,
																		borderColor: s.hsm
																			? palette.success.main
																			: s.hsm === false
																				? palette.error.main
																				: palette.warning.main,
																	}}
																	icon={
																		<FingerprintIcon
																			style={{
																				color: s.hsm
																					? palette.success.main
																					: s.hsm === false
																						? palette.error.main
																						: palette.warning.main,
																			}}
																		/>
																	}
																	label={
																		s.hsm
																			? "Mandat signé"
																			: s.hsm === false
																				? "Refus"
																				: "Mandat en attente de signature"
																	}
																/>
															</Tooltip>
														</div>
													)}
												</Fragment>
											)} */}
										</Box>
										<Box p={1}>
											{!state.ctx.mandate && state.ctx.can_erase && !s.ip && (
												<DeleteForeverIcon
													style=" cursor: pointer;"
													color="primary"
													onClick={() => {
														state.ctx.complete
															? app.refPopUp.current.handleChangeState(
																{
																	opened: true,
																	type: "002",
																	params: {
																		title: "Attention",
																		body: (
																			<div>
																				{/* <Typography variant="body1" gutterBottom>
																					Le mandat de vente a déjà été émis, une modification apportée à un ou
																					plusieurs vendeurs va entraîner son annulation et un nouveau processus
																					de signature.
																				</Typography> */}
																				<Typography variant="h5" gutterBottom>
																					Voulez vous vraiment supprimer un vendeur?
																				</Typography>
																			</div>
																		),
																		yes_action: () => {

																			app.refPopUp.current.handleChangeState(
																				{
																					opened: true,
																					type: "009",
																					params: {
																						name: s.name,
																						uid: s.uid
																					},
																				}
																			)

																		},
																	}
																}
															) : app.refPopUp.current.handleChangeState(
																{
																	opened: true,
																	type: "009",
																	params: {
																		name: s.name,
																		uid: s.uid
																	},
																}
															)

													}}
												/>
											)}
										</Box>
									</Box>
									{s.proxied && s.proxied.length > 0 && <Typography variant="h5"><em>Représente</em></Typography>}
									{s.proxied &&
										s.proxied.map((prx) => (
											<Typography variant="body1" display="inline">
												{prx.n},&nbsp;
											</Typography>
										))}
								</Paper>
							</Grid>
						);
					})}

				{state &&
					state.ctx &&
					state.ctx.sellers && state.ctx.sellers.length === 0 && <Grid item xs={12}>
						<Paper style="padding: 10px;">
							<Stack spacing={2} alignItems="center">

								<Typography variant="h5">
									Il n'y a pas de vendeur enregistré
								</Typography>

								<Button
									variant="contained"
									style="width: 200px;"
									onClick={() => {

										app.refPopUp.current.handleChangeState(
											{
												opened: true,
												type: "008",
												users: state.ctx.sellers,
												uid: uid,
												src: "dus",
												side: "VN"
											}
										)


									}}
								>
									Ajouter un vendeur
								</Button>
							</Stack>

						</Paper>
					</Grid>}
			</Grid>
		</div >
	);
}
